
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/aspect-ratio",
      function () {
        return require("private-next-pages/joy-ui/api/aspect-ratio.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/aspect-ratio"])
      });
    }
  